/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptioncanceled1Inputs */

const en_subscriptioncanceled1 = /** @type {(inputs: Subscriptioncanceled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription has been canceled.`)
};

const de_subscriptioncanceled1 = /** @type {(inputs: Subscriptioncanceled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Abonnement wurde gekündigt.`)
};

/**
* | output |
* | --- |
* | "Your subscription has been canceled." |
*
* @param {Subscriptioncanceled1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const subscriptioncanceled1 = /** @type {((inputs?: Subscriptioncanceled1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptioncanceled1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscriptioncanceled1(inputs)
	return de_subscriptioncanceled1(inputs)
});
export { subscriptioncanceled1 as "subscriptionCanceled" }